export const initFlixxNews = function (config) {
  if ($('.flixx_news').length > 0) {
    /**
     * Handle async news loading
     */
    if ($('section.flixx_news a.loadmore').length > 0) {
      $('section.flixx_news a.loadmore').each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();

          let $this = $(this);
          let $resultContainer = $this.parents('section').find('div.results');
          let url = $(this).attr('href');
          let offset = $(this).attr('data-offset');

          $.get(url + '&offset=' + offset, function (data) {
            $resultContainer.append($(data));
          }).done(function () {
            let count = $resultContainer.find('div.tile').length;
            if ($this.parents('section').find('div.topnews').length > 0){
              count += 1;
            }
            $this.attr('data-offset', count);
            if (count >= $this.attr('data-total')) {
              $this.hide();
            } else {
              $this.show();
            }
          });
        });
      });
    }
  }
}
